import httpStore from "@/api/httpStore.js";

export function generateGoogleAds() {
  return httpStore
    .get("/google/generate_file")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function loadGoogleAdsCategories() {
  return httpStore
    .get("/google/categories")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
